import Vue from 'vue'
import Vuex from 'vuex'


import company from "./modules/Company";
import article from "./modules/Article";
import client from "./modules/Client";
import provider from "./modules/Provider";
import user from "./modules/User";
import sell from './modules/Sell';
import purchase from './modules/Purchase';
import invoice from './modules/Invoice';
import receipt from './modules/Receipt';
import auth from './modules/Auth';
import utilsGeneral from './modules/UtilsStore';
import Extra from './modules/Extra';
import Page from './modules/Page';
import Budget from './modules/Budget';
import Stock from './modules/Stock';
import GroupPermission from './modules/GroupPermission'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {},

  getters: {},

  mutations: {},

  actions: {},

  modules: {
    company,
    article,
    client,
    provider,
    user,
    sell,
    purchase,
    invoice,
    receipt,
    auth,
    utilsGeneral,
    Extra,
    Page,
    Budget,
    Stock,
    GroupPermission,
  }

});